(() => {
  const formatCentimetres = (value = '') => value.replace(/-?\d*\.?\d+/g, (number) => {
    const converted = Number(number) * 2.54;
    if (!Number.isFinite(converted)) return number;
    return converted.toFixed(1).replace(/\.0$/, '');
  });

  const setChartUnit = (chart, selectedTab) => {
    const tabs = chart.querySelectorAll('[data-size-chart-unit]');
    const measurements = chart.querySelectorAll('[data-inches]');
    const unit = selectedTab.dataset.sizeChartUnit;

    tabs.forEach((tab) => {
      const isActive = tab === selectedTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
    });

    measurements.forEach((measurement) => {
      const inches = measurement.dataset.inches || '';
      measurement.textContent = unit === 'cm' ? formatCentimetres(inches) : inches;
    });
  };

  const handleUnitClick = (event) => {
    const tab = event.target.closest('[data-size-chart-unit]');
    if (!tab) return;

    const chart = tab.closest('[data-product-size-chart]');
    if (!chart) return;

    event.preventDefault();
    setChartUnit(chart, tab);
  };

  window.initProductSizeCharts = () => {};

  if (!window.productSizeChartUnitListenerAdded) {
    document.addEventListener('click', handleUnitClick);
    window.productSizeChartUnitListenerAdded = true;
  }
})();
